import { Routes } from '~/router/routes'
import { CrmModule } from '~/composables/usePermissionChecker'
import { resolveFullPath } from '~/http/URLUtils'
import type { RouteLocation, RouteLocationRaw } from 'vue-router'

const children = [
  {
    path: '/sale/commissions',
    name: Routes.SALES_COMMISSIONS_INDEX,
    meta: { requiredCrmModule: CrmModule.SALES_COMMISSIONS },
    redirect(to: RouteLocation): RouteLocationRaw {
      redirectToP1CRM('/dashboard/provisions', to)
      return resolveP1route()
    },
  },
  {
    path: '/sale/electronic-contracts',
    name: Routes.SALES_ELECTRONIC_CONTRACTS_INDEX,
    meta: { requiredCrmModule: CrmModule.SALES_DOCUMENTS },
    redirect(to: RouteLocation): RouteLocationRaw {
      redirectToP1CRM('/electronic_contract', to)
      return resolveP1route()
    },
  },
  {
    path: '/sale/events',
    name: Routes.SALES_EVENTS_INDEX,
    meta: { requiredCrmModule: CrmModule.SALES_EVENTS },
    redirect(to: RouteLocation): RouteLocationRaw {
      redirectToP1CRM('/events', to)
      return resolveP1route()
    },
  },
  {
    path: '/sale/sales',
    name: Routes.SALES_SALES_INDEX,
    meta: { requiredCrmModule: CrmModule.SALES_SALES },
    redirect(to: RouteLocation): RouteLocationRaw {
      redirectToP1CRM('/sales', to)
      return resolveP1route()
    },
  },
  {
    path: '/properties',
    name: Routes.PROPERTIES_INDEX,
    meta: { requiredCrmModule: CrmModule.PROPERTIES },
    redirect(to: RouteLocation): RouteLocationRaw {
      redirectToP1CRM('/hotels', to)
      return resolveP1route()
    },
  },
  {
    path: '/properties/reviews',
    name: Routes.PROPERTIES_REVIEWS,
    meta: { requiredCrmModule: CrmModule.PROPERTIES_REVIEWS },
    redirect(to: RouteLocation): RouteLocationRaw {
      redirectToP1CRM('/guest_review/guest_review_report', to)
      return resolveP1route()
    },
  },
  {
    path: '/properties/frauds',
    name: Routes.PROPERTIES_FRAUDS,
    meta: { requiredCrmModule: CrmModule.PROPERTIES_FRAUDS },
    redirect(to: RouteLocation): RouteLocationRaw {
      redirectToP1CRM('/guest_review/frauds', to)
      return resolveP1route()
    },
  },
  {
    path: '/properties/confirmed_unsuccessful_reservations',
    name: Routes.PROPERTIES_CONFIRMED_UNSUCCESSFUL_RESERVATIONS,
    meta: { requiredCrmModule: CrmModule.PROPERTIES_RECALL },
    redirect(to: RouteLocation): RouteLocationRaw {
      redirectToP1CRM('/guest_review/recall', to)
      return resolveP1route()
    },
  },
  {
    path: '/properties/reservations',
    name: Routes.PROPERTIES_RESERVATIONS,
    meta: { requiredCrmModule: CrmModule.PROPERTIES_RESERVATIONS },
    redirect(to: RouteLocation): RouteLocationRaw {
      redirectToP1CRM('/reservations/grid', to)
      return resolveP1route()
    },
  },
  {
    path: '/properties/map',
    name: Routes.PROPERTIES_MAP,
    meta: { requiredCrmModule: CrmModule.PROPERTIES_MAP },
    redirect(to: RouteLocation): RouteLocationRaw {
      redirectToP1CRM('/map', to)
      return resolveP1route()
    },
  },
  {
    path: '/properties/:propertyId',
    name: Routes.PROPERTIES_DETAIL,
    meta: { requiredCrmModule: CrmModule.PROPERTIES },
    redirect(to: RouteLocation): RouteLocationRaw {
      redirectToP1CRM('/hotels/details/:propertyId', to)
      return resolveP1route()
    },
  },
  {
    path: '/ota/partners',
    name: Routes.OTA_PARTNERS,
    meta: { requiredCrmModule: CrmModule.OTA_PARTNERS },
    redirect(to: RouteLocation): RouteLocationRaw {
      redirectToP1CRM('/partners', to)
      return resolveP1route()
    },
  },
  {
    path: '/ota/cooperation',
    name: Routes.OTA_COOPERATION,
    meta: { requiredCrmModule: CrmModule.OTA_COOPERATION },
    redirect(to: RouteLocation): RouteLocationRaw {
      redirectToP1CRM('/hotels/collaborators', to)
      return resolveP1route()
    },
  },
  {
    path: '/ota/cm/rooms_planning',
    name: Routes.OTA_CM_ROOMS_PLANNING,
    meta: { requiredCrmModule: CrmModule.OTA_CM },
    redirect(to: RouteLocation): RouteLocationRaw {
      redirectToP1CRM('/channel_manager/mapping', to)
      return resolveP1route()
    },
  },
  {
    path: '/ota/cm/request',
    name: Routes.OTA_CM_REQUEST,
    meta: { requiredCrmModule: CrmModule.OTA_CM },
    redirect(to: RouteLocation): RouteLocationRaw {
      redirectToP1CRM('/channel_manager/requests', to)
      return resolveP1route()
    },
  },
  {
    path: '/ota/cm/login_credentials',
    name: Routes.OTA_CM_LOGIN_CREDENTIALS,
    meta: { requiredCrmModule: CrmModule.OTA_CM },
    redirect(to: RouteLocation): RouteLocationRaw {
      redirectToP1CRM('/channel_manager/credentials', to)
      return resolveP1route()
    },
  },
  {
    path: '/ota/cm/reservations',
    name: Routes.OTA_CM_RESERVATIONS,
    meta: { requiredCrmModule: CrmModule.OTA_CM },
    redirect(to: RouteLocation): RouteLocationRaw {
      redirectToP1CRM('/channel_manager/reservations', to)
      return resolveP1route()
    },
  },
  {
    path: '/ota/cm/status',
    name: Routes.OTA_CM_STATUS,
    meta: { requiredCrmModule: CrmModule.OTA_CM },
    redirect(to: RouteLocation): RouteLocationRaw {
      redirectToP1CRM('/channel_manager/status', to)
      return resolveP1route()
    },
  },
  {
    path: '/ota/cm/dashboard',
    name: Routes.OTA_CM_DASHBOARD,
    meta: { requiredCrmModule: CrmModule.OTA_CM },
    redirect(to: RouteLocation): RouteLocationRaw {
      redirectToP1CRM('/channel_manager/dashboard', to)
      return resolveP1route()
    },
  },
  {
    path: '/invoice/fee-invoices',
    name: Routes.INVOICE_FEE_INVOICES,
    meta: { requiredCrmModule: CrmModule.INVOICES },
    redirect(to: RouteLocation): RouteLocationRaw {
      redirectToP1CRM('/operations/list', to)
      return resolveP1route()
    },
  },
  {
    path: '/invoice/fee-invoices',
    name: Routes.INVOICE_SALES_INVOICES,
    meta: { requiredCrmModule: CrmModule.INVOICES },
    redirect(to: RouteLocation): RouteLocationRaw {
      redirectToP1CRM('/sales/invoices', to)
      return resolveP1route()
    },
  },
  {
    path: '/invoice/commission-invoices',
    name: Routes.INVOICE_COMMISSION_INVOICES,
    meta: { requiredCrmModule: CrmModule.INVOICES },
    redirect(to: RouteLocation): RouteLocationRaw {
      redirectToP1CRM('/bonuses/paid_invoices', to)
      return resolveP1route()
    },
  },
  {
    path: '/invoice/performance-invoices',
    name: Routes.INVOICE_PERFORMANCE_INVOICES,
    meta: { requiredCrmModule: CrmModule.INVOICES },
    redirect(to: RouteLocation): RouteLocationRaw {
      redirectToP1CRM('/performance_invoices', to)
      return resolveP1route()
    },
  },
  {
    path: '/invoice/fees-report',
    name: Routes.INVOICE_FEES_REPORT,
    meta: { requiredCrmModule: CrmModule.INVOICES },
    redirect(to: RouteLocation): RouteLocationRaw {
      redirectToP1CRM('/fees_report', to)
      return resolveP1route()
    },
  },
  {
    path: '/invoice/commission-per-hotel',
    name: Routes.INVOICE_COMMISSION_REPORT,
    meta: { requiredCrmModule: CrmModule.INVOICES },
    redirect(to: RouteLocation): RouteLocationRaw {
      redirectToP1CRM('/bonuses/search', to)
      return resolveP1route()
    },
  },
  {
    path: '/invoice/commission-per-hotel',
    name: Routes.INVOICE_COMMISSION_PER_HOTEL,
    meta: { requiredCrmModule: CrmModule.INVOICES },
    redirect(to: RouteLocation): RouteLocationRaw {
      redirectToP1CRM('/bonuses/by_hotel', to)
      return resolveP1route()
    },
  },
  {
    path: '/invoice/import-bank-statements',
    name: Routes.INVOICE_IMPORT_BANK_STATEMENTS,
    meta: { requiredCrmModule: CrmModule.INVOICES },
    redirect(to: RouteLocation): RouteLocationRaw {
      redirectToP1CRM('/bank_log_file', to)
      return resolveP1route()
    },
  },
  {
    path: '/invoice/import-bank-operations',
    name: Routes.INVOICE_BANK_OPERATIONS,
    meta: { requiredCrmModule: CrmModule.INVOICES },
    redirect(to: RouteLocation): RouteLocationRaw {
      redirectToP1CRM('/bank_log', to)
      return resolveP1route()
    },
  },
  {
    path: '/users/index',
    name: Routes.USERS_INDEX,
    meta: { requiredCrmModule: CrmModule.USERS },
    redirect(to: RouteLocation): RouteLocationRaw {
      redirectToP1CRM('/users', to)
      return resolveP1route()
    },
  },
  {
    path: '/users/roles',
    name: Routes.USERS_ROLE,
    meta: { requiredCrmModule: CrmModule.USERS_ROLES },
    redirect(to: RouteLocation): RouteLocationRaw {
      redirectToP1CRM('/role', to)
      return resolveP1route()
    },
  },
  {
    path: '/system/pay/terminals',
    name: Routes.SYSTEM_PAY_TERMINALS,
    meta: { requiredCrmModule: CrmModule.SYSTEM_PREVIO_PAY },
    redirect(to: RouteLocation): RouteLocationRaw {
      redirectToP1CRM('/pay/terminal_setting', to)
      return resolveP1route()
    },
  },
  {
    path: '/system/pay/online-gateway',
    name: Routes.SYSTEM_PAY_ONLINE_GATEWAY,
    meta: { requiredCrmModule: CrmModule.SYSTEM_PREVIO_PAY },
    redirect(to: RouteLocation): RouteLocationRaw {
      redirectToP1CRM('/pay/online_payment_setting', to)
      return resolveP1route()
    },
  },
  {
    path: '/system/sites',
    name: Routes.SYSTEM_SITES,
    meta: { requiredCrmModule: CrmModule.SYSTEM_SITES },
    redirect(to: RouteLocation): RouteLocationRaw {
      redirectToP1CRM('/sites', to)
      return resolveP1route()
    },
  },
  {
    path: '/system/enumerations/spa-procedures',
    name: Routes.SYSTEM_ENUMERATIONS_SPA_PROCEDURES,
    meta: { requiredCrmModule: CrmModule.SYSTEM_SPA_PROCEDURES },
    redirect(to: RouteLocation): RouteLocationRaw {
      redirectToP1CRM('/enumerations/spa_procedures', to)
      return resolveP1route()
    },
  },
  {
    path: '/system/tipbox',
    name: Routes.SYSTEM_TIPBOX,
    meta: { requiredCrmModule: CrmModule.SYSTEM_TIPBOX },
    redirect(to: RouteLocation): RouteLocationRaw {
      redirectToP1CRM('/tip_box', to)
      return resolveP1route()
    },
  },
  {
    path: '/system/feedback',
    name: Routes.SYSTEM_FEEDBACK,
    meta: { requiredCrmModule: CrmModule.SYSTEM_FEEDBACK },
    redirect(to: RouteLocation): RouteLocationRaw {
      redirectToP1CRM('/feedback', to)
      return resolveP1route()
    },
  },
]

function redirectToP1CRM(P1path: string, to: RouteLocation) {
  window.location.href =
    import.meta.env.CRM_FE_P1_APP_URL +
    resolveFullPath(P1path, to.params, {}) +
    '#/' +
    (Object.keys(to.query).length > 0 ? JSON.stringify(to.query) : '')
}

const resolveP1route = (): string => {
  return ''
}

export default children
